const DataExchangeService = () => import('Views/dataExchangeService/index-new-ui');

export default[
  { path: '/dataExchangeService', component: DataExchangeService },
];



// WEBPACK FOOTER //
// ./src/router/dataExchangeService.js